var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CSvgImage',{attrs:{"src":_vm.url,"svg-class":"w-20 h-20"}})}
var staticRenderFns = []

export { render, staticRenderFns }